import PropTypes from 'prop-types';
import { useMantineTheme } from '@mantine/core';

/**
 * TimeFormatter is a formatter which simply passes strings trough and adds ' Uhr', but
 * returns a dash for empty or null values.
 */
export const TimeFormatter = ({ value, testId }) => {
  const { colorScheme, colors } = useMantineTheme();

  return (
    <span
      className="form-control"
      data-testid={testId}
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        backgroundColor: colorScheme === 'dark' ? colors.dark[6] : 'white',
        color: colorScheme === 'dark' ? '#fff' : '#000',
        border: `1px solid ${colorScheme === 'dark' ? colors.dark[5] : colors.gray[2]}`,
      }}
    >
      {value === '' || value === null || value === undefined ? '-' : `${value} Uhr`}
    </span>
  );
};

TimeFormatter.propTypes = {
  value: PropTypes.string,
};
